import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { customerTicketDetailsContext } from '../../CustomerTicketDetailsContext';
import Orders from './Orders';
import WorkOrders from './WorkOrders';


let LinkedOrders = () => {
    let { formatMessage } = useIntl();

    let { ticket } = useContext(customerTicketDetailsContext);

    return (
        <Grid container>
            <Grid item xs>
                {ticket.orders.length > 0 && <Orders />}
                {ticket.workOrders.length > 0 && <WorkOrders />}
                
                {ticket.orders.length === 0 && ticket.workOrders.length === 0 &&
                    <Typography>
                        {formatMessage({ id: LocalizationIds.NoSelectedOrders })}
                    </Typography>
                }
            </Grid>
        </Grid>
    )
}

export default LinkedOrders;